import moment from "moment";
import $ from "jquery";
// import { set } from "lodash";
const generateSelectorDate = (selectorPrefix, element) => {
  return `${selectorPrefix} td[data-day='${element}']`;
};
const formatDate = (elementDiary) => {
  return moment(elementDiary.diaryDate).format("YYYY/MM/DD");
};
const showDateHighLight = (
  diaries_privious,
  diaries_current,
  isCopyModal = false,
  isDiaryList = false
) => {
  let listPrevious = [],
    listCurrent = [];
  let selectorPrefix = "#input-meeting-date";
  if (isCopyModal) {
    selectorPrefix = "#copy-diary-source-date";
  } else if (isDiaryList) {
    selectorPrefix = ".diary-list-date-picker-input-meeting-date";
  }

  diaries_privious.forEach((element) => {
    listPrevious.push(formatDate(element));
  });
  diaries_current.forEach((element) => {
    listCurrent.push(formatDate(element));
  });
  //remove old hightlight
  listPrevious.forEach((element) => {
    let selector = generateSelectorDate(selectorPrefix, element);
    $(selector).removeClass("calendar-height-light");
  });
  // highlight
  listCurrent.forEach((element) => {
    let selector = generateSelectorDate(selectorPrefix, element);
    $(selector).addClass("calendar-height-light");
  });
};

export function resetSignsDiaryBeforeCopy(signs) {
  const signsResult = [];
  for (let i = 1; i <= 8; i++) {
    // signs配列の要素が存在しない場合は新しいオブジェクトを作成
    const sign = signs && signs[i - 1] ? signs[i - 1] : {};

    // signオブジェクトが存在しない場合は初期化
    if (!sign.sign) {
      sign.sign = {};
    }

    // 直接プロパティを設定
    sign.order = i;
    sign.sign.name = "";
    sign.sign.presignedUrl = "";

    signsResult.push(sign);
  }
  console.log(signsResult);
  return signsResult;
}

export default { showDateHighLight };
